import { client } from "Service/axios";
import {
  AI_INSPECTION_ANALYZE,
  AI_INVOICE_ANALYZE,
} from "Shared/Constants/apiRequest";
import {
  AIRequest,
  AIResponse,
  AIInvoiceRequest,
  AIInvoiceResponse,
} from "Shared/Types/ai";

class AI {
  inspectionImageAnalyze(image: AIRequest) {
    return client.post<AIResponse>(AI_INSPECTION_ANALYZE, image);
  }
  analyzeInvoice(file: AIInvoiceRequest) {
    return client.post<AIInvoiceResponse>(AI_INVOICE_ANALYZE, file);
  }
}
export default AI;
